module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-27-7d1caeb101c3a8fcfe7e9b76f9bc8f6e.png";